import { LegalPage, Section } from "@/components/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" testId="privacy-title">
      <Section title="1. Information We Collect">
        <p>We collect:</p>
        <ul>
          <li><strong>Account data:</strong> name, email, password hash, role.</li>
          <li><strong>Profile data:</strong> bio, avatar, location, website, discography links you choose to share.</li>
          <li><strong>Assessment responses:</strong> answers, score, missing items, recommendations.</li>
          <li><strong>Evidence uploads:</strong> screenshots, PDFs, certificates you submit for verification.</li>
          <li><strong>Learning data:</strong> lessons completed, exam attempts, certifications earned.</li>
          <li><strong>Payment metadata:</strong> Stripe Checkout session IDs, customer IDs, subscription IDs, and amounts. We do not store full card numbers.</li>
          <li><strong>Usage data:</strong> pages viewed, features used, IP address, browser/device type, timestamps.</li>
        </ul>
      </Section>

      <Section title="2. How We Use Information">
        <ul>
          <li>To provide platform functionality (account, score, passport, courses).</li>
          <li>To generate personalized course recommendations.</li>
          <li>To process payments via Stripe and grant subscription access.</li>
          <li>To send transactional emails (verification, password reset, payment receipts) via Resend.</li>
          <li>To improve the Platform and develop new features.</li>
          <li>To detect fraud, abuse, or violations of our <a href="/aup">Acceptable Use Policy</a>.</li>
        </ul>
      </Section>

      <Section title="3. Public Information">
        <p>Your BeatCredsi Passport (at <code>beatcredsi.com/c/{`{username}`}</code>) is publicly accessible by default. It displays the information you choose to make visible: name, avatar, bio, score, certifications, achievements, discography links. We index passports in search engines.</p>
      </Section>

      <Section title="4. Data Sharing">
        <p>BeatCredsi <strong>does not sell</strong> personal information. We share information only:</p>
        <ul>
          <li>With service providers (Stripe for payments, Resend for email, MongoDB Atlas for database, Emergent for hosting and object storage) under data-processing agreements.</li>
          <li>When required by law, court order, or to protect rights and safety.</li>
          <li>In connection with a merger, acquisition, or sale of assets (with notice to you).</li>
        </ul>
      </Section>

      <Section title="5. Security">
        <p>Passwords are hashed with bcrypt. Sessions use httpOnly secure cookies. Connections are TLS-encrypted. We use reasonable safeguards, but no system can guarantee complete security.</p>
      </Section>

      <Section title="6. Cookies &amp; Tracking">
        <p>See our <a href="/cookies">Cookie Policy</a> for details on cookies, local storage, and tracking technologies.</p>
      </Section>

      <Section title="7. Your Rights">
        <p>You may request:</p>
        <ul>
          <li>Access to your data</li>
          <li>Correction of inaccurate data</li>
          <li>Deletion of your account and associated data (subject to legal retention obligations)</li>
          <li>Export of your data in a portable format</li>
        </ul>
        <p>Email <a href="mailto:contact@onlymartian.com">contact@onlymartian.com</a>.</p>
      </Section>

      <Section title="8. Email Communications">
        <p>Transactional emails (verification, receipts, password resets) are required for account function and cannot be opted out of without closing your account. Marketing emails (if any) include an unsubscribe link.</p>
      </Section>

      <Section title="9. International Transfers">
        <p>Your data may be processed in the United States or other countries where our service providers operate.</p>
      </Section>

      <Section title="10. Children's Privacy">
        <p>BeatCredsi is not intended for individuals under 13. We do not knowingly collect information from children. If you believe a child has provided data, contact us for prompt deletion.</p>
      </Section>

      <Section title="11. Data Retention">
        <p>We retain account data while your account is active. After account deletion, we may retain payment records as required by law (typically 7 years for tax purposes), and de-identified aggregate analytics indefinitely.</p>
      </Section>

      <Section title="12. Changes">
        <p>We may update this Policy. Material changes will be announced via email or in-app notice.</p>
      </Section>

      <Section title="13. Contact">
        <p>Email <a href="mailto:contact@onlymartian.com">contact@onlymartian.com</a>.</p>
      </Section>
    </LegalPage>
  );
}
